/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component } from '@angular/core';

@Component({
  templateUrl: './license-not-valid.component.html'
})
export class LicenseNotValidComponent {

}
